<template>
  <div class="menu-item blog-item" :class="{ active }">
    <dropdownMenu direction="center" :overlay="false">
      <template #trigger>
        <div class="btn" @click="() => $emit('open')">
          {{ name }}
          <img :src="menuOpen" class="menu-icon-open" alt="Menu" />
          <img :src="menuClosed" class="menu-icon-closed" alt="Menu" />
        </div>
      </template>

      <template #body>
        <div class="dropdown">
          <div
            class="dropdown-item"
            v-for="item in items"
            :key="item.title"
            :item="item"
          >
            <a :href="item.link" :target="item.isExt ? '_blank' : '_self'">
              <HeaderDropdownItemContent :item="item" />
            </a>
          </div>
        </div>
      </template>
    </dropdownMenu>
  </div>
</template>

<script>
import DropdownMenu from "v-dropdown-menu/vue2";

import HeaderDropdownItemContent from "./HeaderDropdownItemContent.vue";

import menuOpen from "../../assets/menu-open.svg";
import menuClosed from "../../assets/menu-closed.svg";

export default {
  components: {
    DropdownMenu,
    HeaderDropdownItemContent,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      menuOpen,
      menuClosed,
    };
  },
};
</script>

<style lang="scss">
.menu-item {
  .v-dropdown-menu {
    .btn {
      cursor: pointer;

      .menu-icon-open,
      .menu-icon-closed {
        position: relative;
        top: 2px;
      }

      .menu-icon-open {
        display: none;
      }
    }

    &.v-dropdown-menu--active {
      .btn {
        .menu-icon-open {
          display: inline-block;
        }

        .menu-icon-closed {
          display: none;
        }
      }
    }

    .v-dropdown-menu__container {
      width: 384px;
      min-width: 384px;

      border-radius: 12px;
      border: 1px solid $neutral200;
      background: #fff;
      padding: 16px;

      /* Shadow/lg */
      box-shadow: 0px 4px 6px -2px rgba(16, 24, 40, 0.03),
        0px 12px 16px -4px rgba(16, 24, 40, 0.08);

      transform: translateX(-50%) translateY(12px) !important;

      .dropdown {
        .dropdown-item > a {
          display: block;
          padding: 16px;
          cursor: pointer;
          border-radius: 8px;

          &:hover {
            background: $neutral50;
          }

          &::after {
            content: "";
            display: block;
            clear: both;
          }
        }
      }
    }
  }
}
</style>